export default import.meta.ROLLDOWN_FILE_URL_OT_K$F8o4heI5qTaR0c68w